module.exports = __webpack_public_path__ + "static/values.b7dc329f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/values.jpg
// module id = 135
// module chunks = 35783957827783 257680017402065